import { vezgoConfig } from '@/config';

/**
 * Processing state for Vezgo connections
 */
export enum ConnectionProcessingState {
  IDLE = 'idle',
  CONNECTING = 'connecting',
  LOADING_ACCOUNTS = 'loading_accounts',
  REFRESHING = 'refreshing',
  DISCONNECTING = 'disconnecting',
  PROCESSING = 'processing',
  COMPLETE = 'complete',
  FAILED = 'failed',
  ERROR = 'error'
}

/**
 * Standard Vezgo processing states as object for simpler imports
 */
export const PROCESSING_STATE = {
  IDLE: ConnectionProcessingState.IDLE,
  CONNECTING: ConnectionProcessingState.CONNECTING,
  LOADING_ACCOUNTS: ConnectionProcessingState.LOADING_ACCOUNTS,
  REFRESHING: ConnectionProcessingState.REFRESHING,
  DISCONNECTING: ConnectionProcessingState.DISCONNECTING,
  PROCESSING: ConnectionProcessingState.PROCESSING,
  COMPLETE: ConnectionProcessingState.COMPLETE,
  FAILED: ConnectionProcessingState.FAILED,
  ERROR: ConnectionProcessingState.ERROR
};

/**
 * Toast notification duration in milliseconds
 */
export const TOAST_DURATION = 5000;

/**
 * Standard Vezgo parameter names for URLs
 */
export const VEZGO_PARAMS = {
  PROVIDER: 'provider',
  ERROR: 'error',
  STATE: 'state',
  CLIENT_ID: 'client_id'
} as const;

/**
 * Default provider display name
 */
export const DEFAULT_PROVIDER_DISPLAY_NAME = 'Service Provider';

/**
 * Connect and callback URLs
 */
export const VEZGO_CONNECT_URL = vezgoConfig.connectUrl;
export const VEZGO_CALLBACK_PATH = '/investments/connect/vezgo';
export const VEZGO_LEGACY_CALLBACK_PATH = '/vezgo-callback';

/**
 * Default Vezgo client ID from configuration
 */
export const VEZGO_CLIENT_ID = vezgoConfig.clientId;

/**
 * Registered redirect URIs for Vezgo callbacks
 */
export const VEZGO_REGISTERED_REDIRECT_URIS = vezgoConfig.registeredRedirectURIs;

/**
 * Default return path after Vezgo operations
 */
export const VEZGO_RETURN_PATH = '/investments';

/**
 * Current redirect URI for this environment
 */
export const VEZGO_REDIRECT_URI = vezgoConfig.redirectUri;

// Remove VEZGO_STORAGE_KEYS export and re-export from storage-keys
export { VezgoStorageKeys } from './utils/storage-keys';
